import { tickerItems } from "@/mocks/homeData";

export default function TickerBand() {
  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="px-4 md:px-8 h-12 flex items-center gap-4 overflow-hidden">
        <span className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-600 text-background-50 text-xs font-medium">
          <i className="ri-live-line animate-soft-pulse" /> 实时更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex items-center gap-8 whitespace-nowrap ticker-track">
            {[...tickerItems, ...tickerItems].map((text, idx) => (
              <span key={`${text}-${idx}`} className="text-sm text-foreground-700 inline-flex items-center gap-2">
                <i className="ri-record-circle-line text-[8px] text-accent-500" /> {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}